const ByCity = ({ city, totalLeads }) => {
    return (
        <div>
            <div className="card mb-2">
                <div className="align-items-center p-2 card-header">
                    <div className="font-weight-bold float-left">By City (Top 10)</div>
                </div>
                <div className="card-body p-2">
                    <table className="table table-card table-borderless table-striped table-hover">
                        <thead className="border-bottom">
                            <tr>
                                <th scope="col">City</th>
                                <th scope="col">Region</th>
                                <th scope="col">Country</th>
                                <th scope="col" className="text-right">
                                    Lead %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {city.length === 0 ? (
                                <tr>
                                    <td colSpan={4}>No stats available</td>
                                </tr>
                            ) : (
                                city.map((item, index) => (
                                    <tr key={`${index}-${item.ip_city}`}>
                                        <td>{item.ip_city}</td>
                                        <td>{item.ip_region}</td>
                                        <td>{item.ip_country}</td>
                                        <td align="right">{totalLeads > 0 ? Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((item.lead_count / totalLeads) * 100) : 0}%</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ByCity
